import React from 'react';
import { Camera, Layers, Download, CheckCircle } from 'lucide-react';
import type { InsightsSummary } from '../../api/insights';
import styles from './InsightsSummaryRow.module.css';

interface Props {
  data: InsightsSummary;
}

function headroomColor(pct: number): string {
  if (pct < 20) return styles['value--red'];
  if (pct < 40) return styles['value--amber'];
  return styles['value--green'];
}

function rateColor(pct: number): string {
  if (pct < 90) return styles['value--red'];
  if (pct < 98) return styles['value--amber'];
  return styles['value--green'];
}

export function InsightsSummaryRow({ data }: Props) {
  const cards = [
    {
      icon: <Camera size={16} />,
      label: 'Photos This Month',
      value: data.photosThisMonth.toLocaleString(),
      valueClass: '',
    },
    {
      icon: <Layers size={16} />,
      label: 'Quota Headroom',
      value: `${data.quotaHeadroomPercent}%`,
      valueClass: headroomColor(data.quotaHeadroomPercent),
      sub: 'lowest across all events',
    },
    {
      icon: <Download size={16} />,
      label: 'Total Downloads',
      value: data.totalDownloads.toLocaleString(),
      valueClass: '',
    },
    {
      icon: <CheckCircle size={16} />,
      label: 'Processing Success',
      value: `${data.processingSuccessRate}%`,
      valueClass: rateColor(data.processingSuccessRate),
    },
  ];

  return (
    <div className={styles.row}>
      {cards.map((card) => (
        <div key={card.label} className={styles.card}>
          <div className={styles['card-icon']}>{card.icon}</div>
          <div className={styles['card-body']}>
            <span className={styles.label}>{card.label}</span>
            <span className={`${styles.value} ${card.valueClass}`}>{card.value}</span>
            {card.sub && <span className={styles.sub}>{card.sub}</span>}
          </div>
        </div>
      ))}
    </div>
  );
}
